import Header from '@/shared/components/Header/Header';
import { IonContent, IonPage, IonRefresher, IonRefresherContent } from '@ionic/react';
import { ReactNode } from 'react';
import Footer from '../Footer/Footer';
import styles from './PageWrapper.module.css';

type PageWrapperType = {
  children?: ReactNode;
  isHome?: boolean;
  showFooter?: boolean;
  mainPage?: boolean;
  name: string;
  noAuth?: boolean;
  noHeader?: boolean;
  styles?: string;
  className?: string;
};

const PageWrapper: React.FC<PageWrapperType> = ({
  children,
  isHome = false,
  showFooter = false,
  mainPage = false,
  name,
  noAuth = false,
  noHeader,
  className
}) => {
  const doRefresh = (e: CustomEvent) => {
    setTimeout(() => {
      e.detail.complete();
    }, 3000);
  };

  return (
    <IonPage id={name} className={`${styles.page} ${className || ''}`}>
      {!noHeader && !mainPage && <Header name={name} />}
      {!noHeader && mainPage && <Header mobileMainPage={true} name={name} />}

      <IonContent
        scrollEvents={false}
        className={`${noAuth ? styles.brandBackground : ''} ${isHome ? styles.homePage : ''}`}
      >
        <IonRefresher slot="fixed" onIonRefresh={doRefresh} pullFactor={0.5} pullMin={100} pullMax={200}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>
        <main className={noAuth ? styles.noAuthWrapper : styles.wrapper}>{children}</main>
        {showFooter && <Footer />}
      </IonContent>
    </IonPage>
  );
};

export default PageWrapper;
